
import { Component, Vue } from 'vue-property-decorator'
import { PersonService } from '@/services'
import RowWrap from '@/components/detail/row_wrap/index.vue'
import RowItem from '@/components/detail/row_item/index.vue'

const statusMap = new Map([
    [1, { zh: '审核中', en: 'Ing' }],
    [2, { zh: '审核通过', en: 'Pass' }],
    [3, { zh: '审核不通过', en: 'Fail' }]
])

@Component({
    name: 'person-settle-detail',
    components: {
        RowWrap,
        RowItem
    }
})
export default class extends Vue {
    private changeLoading = false
    private personId = ''
    private person: any = { 
        avatar: '', 
        status: '', 
        user: {}, 
        type: { id: '' },
        link: [],
        post: [],
        person: {}
    }
    private isUpdateLoading = false

    get matchStatus() {
        const status = {
            1: '审核中',
            2: '审核通过',
            3: '审核不通过'
        }
        return Reflect.get(status, this.person.status)
    }

    // 匹配状态中文
    get matchStatusZh() {
        const status = statusMap.get(this.person.status)
        if (!status) return ''
        return status!.zh
    }

    // 匹配状态对象
    get status() {
        let statusKeyValue = {}
        const values = [...statusMap.values()]
        const keys = [...statusMap.keys()]
        values.forEach((val, index) => {
            Reflect.set(statusKeyValue, val.en, keys[index])
        })
        return statusKeyValue
    }

    private created() {
        this.personId = this.$route.params.id
        this.$title(`Loading | ${this.$route.meta.title} - 庖丁`)
    }

    private mounted() {
        this.getPersonDetail()
    }

    /** 获取人物详情 */
    private async getPersonDetail() {
        const params = {
            id: +this.personId
        }
        const result = await PersonService.getEditInfoDetail(params)
        if (result.status === 200) {
            
            let { link, post } = result.data
            try {
                link = typeof link === 'string' ? JSON.parse(link) : (link || [])
                post = typeof post === 'string' ? JSON.parse(post) : (post || [])
            } catch (e) {
                link = []
                post = []
            }
            result.data.link = link.map((url: string, index: number) => ({ key: index, value: url }))
            result.data.post = post
            this.person = result.data
            this.$title(`${this.person.person.name}| ${this.$route.meta.title} - 庖丁`)
        }
    }

    private matchButtonType(status: number) {
        return this.person.status === status ? 'primary' : 'default'
    }

    /** 改变状态 */
    private async changeStatus(status: number) {
        if (this.person.status === status) return
        this.changeLoading = true
        const params = {
            id: +this.personId,
            status
        }
        const result = await PersonService.updateEditInfoStatus(params)
        this.changeLoading = false
        if (result.status === 200) {
            this.person.status = status
            return this.$message({
                showClose: true,
                type: 'success',
                message: '修改状态成功'
            })
        }
        this.$message({
            showClose: true,
            type: 'error',
            message: result.message || '发生错误, 修改状态失败'
        })
    }

    private showLoading() {
        this.isUpdateLoading = true
    }

    private hideLoading() {
        this.isUpdateLoading = false
    }
}
